export const text = {
  title: 'Plants',
  sectionTitle: 'All plants',
  addPlant: '+ Add plant',
  searchPlaceholder: 'Search plants...',
  allCategories: 'All',
  emptyTitle: 'No plants found',
  emptyHint: 'Try a different search or category filter.',
  plantsTotal: (count: number) => `Total: ${count} plants`,
  yourPlantBadge: 'Yours',
  createDialogTitle: 'Add your plant',
  createDialogDescription: 'Create a custom plant that appears in your garden planner.',
  editDialogTitle: 'Edit plant',
  editDialogDescription: 'Update your custom plant details.',
  deleteDialogTitle: 'Delete plant?',
  deletePlant: 'Delete plant',
  plantNameLabel: 'Name',
  plantNamePlaceholder: 'Enter plant name...',
  plantEmojiLabel: 'Emoji',
  plantEmojiPlaceholder: '🌱',
  plantCategoryLabel: 'Category',
  savePlant: 'Save plant',
  createError: 'Could not create plant. Please try again.',
  updateError: 'Could not update plant. Please try again.',
  deleteError: 'Could not delete plant. Please try again.',
  deleteDialogDescription: (name: string) =>
    `Are you sure you want to delete "${name}"? This cannot be undone.`,
  editPlant: 'Edit plant',
  deletePlantAction: 'Delete plant',
};
